import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import routes from './Constant';
import { PageLoader } from '../common/components';
import { useAuth } from '../authContext/useAuth';
import NotAuthorized from '../pages/NotAuthorized';
import { PermissionSubcategory, hasSubcategoryAccess, hasCategoryAccess } from '../utils/permissionConstants';

interface PrivateRouteProps {
  requiredCategory?: any;
  requiredSubcategory?: PermissionSubcategory;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredCategory, requiredSubcategory }) => {
  const auth = useAuth();
  const { isInitialized, isAuthenticated, permission, user } = auth;

  if (!isInitialized) {
    return <PageLoader />;
  }
  if (!isAuthenticated) {
    return <Navigate to={routes.login} />;
  }

  const categoryPermissions = hasCategoryAccess(permission, requiredCategory, user);

  if (categoryPermissions !== undefined && categoryPermissions !== null) {
    if (requiredSubcategory) {
      const allowed = hasSubcategoryAccess(permission, requiredCategory, requiredSubcategory, user);
      return allowed ? <Outlet /> : <NotAuthorized />;
    }
    return <Outlet />;
  }

  return <NotAuthorized />;
};

export default PrivateRoute;
